<template>
  <div class="mobile">
    <div class="mobile-item mobile--modal" v-if="getToggled"></div>
    <div class="mobile-item mobile--nav" :class="menuClass">
      <nav>
        <NavList></NavList>
      </nav>
    </div>
  </div>
</template>

<script>
import NavList from "./NavList";
import { mapGetters } from "vuex";

export default {
  components: {
    NavList
  },
  computed: {
    ...mapGetters(["getToggled"]),
    menuClass() {
      return this.getToggled ? "nav--open" : "";
    }
  }
};
</script>

<style scoped lang="scss">
</style>